// extracted by mini-css-extract-plugin
export default {"input-container":"InputCustom_input-container__ArloP","results-container":"InputCustom_results-container__NzO83","prod":"InputCustom_prod__9Nvx6","item":"InputCustom_item__1ObYU"};